import React from "react";
import ReactDOM from "react-dom";

import "./index.css";

import RouterAuth from "./components/RouterAuth";
import registerServiceWorker from "./registerServiceWorker";

import * as stores from "./stores";

import { Provider } from "mobx-react";

import { ConfigProvider } from "antd";

import it_IT from "antd/lib/locale-provider/it_IT";
import en_US from "antd/lib/locale-provider/en_US";

import "moment/locale/it";

import moment from "moment";

const [language] = (navigator.language || navigator.userLanguage || "en").split("-");

stores["translationsStore"].setLanguage(localStorage.getItem("currentLanguage") || navigator.language || navigator.userLanguage || "en");

let locale = en_US;
moment.locale("en");

if (language === "it") {
  locale = it_IT;
  moment.locale("it");
}

const m = moment();

stores["translationsStore"].setLongDateFormat(m._locale._longDateFormat);

if (process.env.REACT_APP_ENV === 'production' && window.location.protocol !== 'https:') {
  window.location = 'https:' + window.location.href.substring(window.location.protocol.length);
}

ReactDOM.render(
  <ConfigProvider locale={locale}>
    <Provider {...stores}>
      <RouterAuth />
    </Provider>
  </ConfigProvider>,
  document.getElementById("root")
);

//https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#making-a-progressive-web-app
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js